import { render } from "./newClients.vue?vue&type=template&id=029ad4b2&scoped=true"
import script from "./newClients.vue?vue&type=script&lang=js"
export * from "./newClients.vue?vue&type=script&lang=js"

import "./newClients.vue?vue&type=style&index=0&id=029ad4b2&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029ad4b2"]])

export default __exports__